module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/icon_mn-badge-1227fc27a869838af025194cc5bd050f.svg";